
import ApiGenericServicesData from 'services/ApiGenericServicesData';

export default class GenerarInformeCierre extends ApiGenericServicesData{
    constructor(){
        super("generarInformeCierre");
    }
    informe(data) { return this.customPATCH("informe",data); }  
    obtenerBase64(data) { return this.customGET("obtenerBase64/"+data.coddep+'/'+data.codmun); }  
    estadisticas(data) { return this.customGET("estadisticas/"+data.coddep+'/'+data.tipo); }  
    getDeptoMpioUsuarioInforme() { return this.customGET("getDeptoMpioUsuarioInforme"); }  
}